// API Base Url
export const PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const ACCESS_TOKEN_DURATION = process.env.NEXT_PUBLIC_ACCESS_TOKEN_DURATION;
export const REFRESH_TOKEN_DURATION = process.env.NEXT_PUBLIC_REFRESH_TOKEN_DURATION;

// Get Access Token
export const GET_ACCESS_TOKEN = '/getAccessToken';

// get tenant home page data
export const HOME_PAGE = '/home-page';
export const CUSTOM_PAGE = '/custom-page';
export const PAGE = '/page';
export const PAGES = '/pages';
export const CONGRATULATIONS = '/congratulations';
export const WAITING = '/waiting';

export const LOGIN = '/login';
export const REGISTER = '/register';

export const WEBINAR = '/webinar';
export const WEBINARS = '/webinars';
export const WEBINAR_QUESTION = '/questions';
export const WEBINAR_REPLY = '/reply';
export const WEBINAR_REPLIES = '/replies';
export const WEBINAR_TIME_ATTENDED = '/time-attended';
export const WEBINAR_ATTENDED = '/attended';
export const WEBINAR_SETTINGS = '/settings';
export const ONLINE_USERS = '/online-users';
export const ONLINE_CHAT = '/online-chat';
export const MESSAGES = '/messages';

// Step 1

export const LAYOUT_SETTINGS = '/layout-settings';
export const SITE_META = '/site-meta';
export const CHECK_SUB_ACCOUNT = '/check-sub-account';
export const CHECK_CUSTOM_ACCOUNT = '/check-custom-account';

// ====================================
// Tenant
export const TENANT_REGISTER = '/tenant-register';
export const FORGOT_PASSWORD = '/forgot-password';
export const TENANT_LOGIN = '/tenant-login';
export const TENANT_RESET_PASSWORD = '/reset-password';
export const TENANT_LOGOUT = '/tenant-logout';

// checkLoggedInUser
export const TENANT_HOME_LOGGED_IN_USER = '/checkLoggedInTenant';
export const TENANT_CHECK_LOGGED_IN_USER = '/checkLoggedInUser';

// subscription

export const CHECK_SUBSCRIPTION_STATUS = '/check-profile-status';

// dashboard-report
export const DASHBOARD_REPORT = '/dashboard-report';

// user profile image upload
export const PROFILE_IMAGE_UPLOAD = '/profile-image';
export const PROFILE_INFORMATION_UPDATE = '/profile/update';
export const PROFILE_SOCIAL_MEDIA_UPDATE = '/profile/social/update';
export const PROFILE_DEACTIVATE = '/profile/deactivate';
export const PROFILE_DELETED = '/profile/deleted';

// webinar

export const STORE_WEBINARS = '/webinars/store';
export const WEBINAR_DEPENDENCE = '/webinars/dependence';
export const WEBINAR_LIST = '/webinars-list';
export const WEBINAR_DELETE = '/webinars-delete';
export const WEBINAR_DUPLICATE = '/webinars-duplicate';
export const WEBINAR_EDIT = '/webinars-edit';
export const UPDATE_WEBINARS = '/webinars/update';
export const UPDATE_WEBINARS_WELCOME_PAGE = '/webinars/welcome/update';
export const UPDATE_WEBINARS_PAGE = '/webinars/page/update';
// webinar setting
export const GET_WEBINAR_SETTING = '/webinars/settings/dependence';
export const UPDATE_WEBINAR_SETTING = '/webinars/settings';

// attendee-list
export const ATTENDEE_LIST = '/webinars/attendee-list';
export const ATTENDEE_HISTORY_LIST = '/webinars/attendee-history-list';
export const WEBINARS_DROPDOWN = '/utility/webinars/dropdown';

// user
export const STORE_USERS = '/users/store';
export const USERS_DEPENDENCE = '/users/dependence';
export const USERS_LIST = '/users-list';
export const USERS_DELETE = '/users-delete';
export const USERS_EDIT = '/users-edit';
export const UPDATE_USERS = '/users/update';

// roles
export const ROLES_LIST = '/roles-list';
export const ROLES_STORE = '/roles-store';
export const ROLES_UPDATE = '/roles-update';
export const ROLES_DELETE = '/roles-delete';

// settings
export const HOME_PAGE_SETTINGS = '/home-page-settings-dependence';
export const HOME_PAGE_SETTINGS_UPDATE = '/home-page-settings-update';

// website settings
export const WEBSITE_SETTINGS = '/website-settings-dependence';
export const WEBSITE_SETTINGS_UPDATE = '/website-settings-update';
export const UPDATE_PASSWORD = '/update-password';
export const LOGOUT = '/logout';

// forms
export const FORMS_DEPENDENCE = '/forms/dependence';
export const FORMS_LIST = '/forms-list';
export const STORE_FORMS = '/form/store';
export const FORMS_DELETE = '/forms-delete';
export const FORMS_EDIT = '/forms-edit';
export const UPDATE_FORMS = '/forms/update';

// option-groups
export const OPTION_GROUPS = '/option-groups';

// support-message
export const SUPPORT_MESSAGES = '/support-messages';

// custom domain
export const REGISTER_MANUAL_CUSTOM_DOMAIN = '/register-manual-custom-domain';
export const REGISTER_CUSTOM_DOMAIN = '/register-custom-domain';
export const UPDATE_CUSTOM_DOMAIN_STATUS = '/update-custom-domain-status';
export const UPDATE_DOMAIN_SETTING = '/update-domain-setting';
export const UPDATE_PLAN_SETTING = '/update-plan-setting';
export const STORE_CUSTOM_DOMAIN = '/store-custom-domain';
export const INSTALL_SSL_DOMAIN = '/install-ssl-domain';

// subscriber
export const SUBSCRIBER_LIST = '/subscriber-list';

// gateway
export const SHURJOPAY_PAY_NOW = '/shurjopay/pay-now';
export const SHURJOPAY_PAY_VERIFY = '/shurjopay/verify';

// transaction
export const TRANSACTION_LIST = '/transactions/list';
export const PLAN_EXTEND = '/shurjopay/plan/extend';

// tiny mce file upload
export const TINY_MCE_FILE_UPLOAD = '/tiny-mce-file-upload';

// MailService
export const SEND_MAIL = '/send-mail';
export const READ_MAIL = '/read-mail';

// admin / user settings
export const FB_META_PIXEL = '/fb-meta-pixel';
export const FB_META_PIXEL_UPDATE = '/update/fb-meta-pixel';
// public
export const GET_PUBLIC_FB_META_PIXEL = '/facebook-meta-pixel-settings';
export const FB_CAPI_EVENT = '/fb-capi-event';

// themes
export const THEMES = '/themes';
export const THEME_SECTIONS = '/sections';
export const THEME_SECTION_FIELD = '/fields';

// custom user pages
export const CUSTOM_USER_PAGES = '/custom-user-pages';
export const CUSTOM_USER_SECTIONS = '/custom-user-page-sections';
export const CUSTOM_USER_SECTION_FIELD = '/custom-user-page-fields';
